export default axios => ({
    getMaterializables(type) {
        return axios.get(`/admin/materializables/`+type)
    },
})
